import React, { CSSProperties, useEffect, useRef, useState } from 'react';
import { View, StyleSheet, ViewStyle, StyleProp } from 'react-native';
import Game from '../../shell/Game';
import { onTakeScreenShot } from '../../shell/utils/appManagementFunctions';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { selectAdvance, setAdvance, TAdvanceINT } from '../../store/slices/AdvanceSlice';
import { GameObject, selectGameObject } from '../../store/slices/gameObjectSlice';
import { GameNames } from '../../store/slices/GameTypes';
import { selectMenu, setMenu, TMenuINT } from '../../store/slices/menuSlice';
import { store } from '../../store/store';
import { doRedo, doUndo } from '../doUndoRedo';
import { MenuOptions } from '../menu/SideBar';

interface TWrapperProps {
    onScroll?(e: any): void,
    onTouchStart(): void,
    style?: StyleProp<ViewStyle> | undefined;
    children?: React.ReactNode;
}

export const TWrapper: React.FC<TWrapperProps> = ({ children, style, onTouchStart: _onTouchStart, onScroll }): JSX.Element => {
    const advanceSlice = useAppSelector(selectAdvance);
    const gameSlice = useAppSelector(selectGameObject).present;
    const menuSlice = useAppSelector(selectMenu);
    const advance = useRef<TAdvanceINT>(advanceSlice);
    const game = useRef<GameObject>(gameSlice);
    const menu = useRef<TMenuINT>(menuSlice);
    const isKeyDown = useRef(false);

    const dispatch = useAppDispatch();

    useEffect(() => {
        advance.current = advanceSlice;
        game.current = gameSlice;
        menu.current = menuSlice;
    }, [advanceSlice, menuSlice]);
    useEffect(() => {

        document.addEventListener('keydown', handleKeyDown);
        document.addEventListener('keyup', handleKeyUp);
        document.addEventListener('scroll', handleScroll);
        document.addEventListener('mouse', handleScroll);
        document.addEventListener('mousedown', handleMouseDown);
        global.electronAPI?.registerToOutOfFocus(() => {
            handleKeyUp();
        });
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            document.removeEventListener('keyup', handleKeyUp);
            document.removeEventListener('scroll', handleScroll);
            document.removeEventListener('mouse', handleScroll);
            document.removeEventListener('mousedown', handleMouseDown);
        };
    }, []);



    const handleMouseDown = async (event: MouseEvent) => {
        if (menu.current.menuState === MenuOptions.INIT || game.current.lastUpdated === GameNames.INIT) { return; }
        if (event.button === 2) {
            if (global.electronAPI) {

                if (Game.isReplayRunning) {
                    store.dispatch(setMenu({ menuState: Game.isReplayRunning ? MenuOptions.SCENES : MenuOptions.SAVE, display: !store.getState().menu.display }));
                    return;
                }
                await global.electronAPI.rightClick();
            }
            store.dispatch(setMenu({ menuState: MenuOptions.SAVE, display: !store.getState().menu.display }));
        } else if (event.button === 1) {

            dispatch(setAdvance({ canAdvance: false, skipping: false, keyPressed: advance.current.keyPressed ? undefined : "KeyH", promise: undefined }));
        }
    };
    const handleKeyDown = async (event: KeyboardEvent) => {
        if (event.shiftKey && event.code === 'Tab') {
            return;
        }
        if (game.current.lastUpdated === GameNames.INIT || isKeyDown.current || (store.getState().menu.display && event.code !== "Escape")) { return; }
        isKeyDown.current = true;
        if (advance.current.keyPressed === "KeyH" && event.code != 'KeyS') {
            dispatch(setAdvance({ canAdvance: false, skipping: false, keyPressed: undefined }));
            return;
        }

        switch (event.code) {
            case "Tab":
                if (advance.current.skipping) {
                    dispatch(setAdvance({ canAdvance: false, skipping: false, keyPressed: undefined, promise: undefined }));
                    break;
                }
                dispatch(setAdvance({ canAdvance: true, skipping: true, keyPressed: event.code, promise: undefined }));
                break;
            case "ControlRight":
            case "ControlLeft":
                dispatch(setAdvance({ canAdvance: true, skipping: true, keyPressed: event.code, promise: undefined }));
                break;

            case "NumpadEnter":
            case "Enter":
            case "Space":

                dispatch(setAdvance({ canAdvance: true, skipping: false, keyPressed: event.code, promise: undefined }));
                break;
            case "KeyH":

                dispatch(setAdvance({ canAdvance: false, skipping: false, keyPressed: advance.current.keyPressed === "KeyH" ? undefined : event.code, promise: undefined }));

                break;
            case "KeyS":
                onTakeScreenShot();
                break;
            case "PageUp":
                doUndo();
                isKeyDown.current = false;
                break;
            case "PageDown":
                doRedo();
                isKeyDown.current = false;
                break;
            case "Escape":
                await global.electronAPI?.rightClick();
                store.dispatch(setMenu({ menuState: Game.isReplayRunning ? MenuOptions.SCENES : MenuOptions.SAVE, display: !store.getState().menu.display }));
                break;

            default:
                dispatch(setAdvance({ canAdvance: false, skipping: true, keyPressed: event.code, promise: undefined }));
                break;
        }



    };
    const handleKeyUp = (event?: KeyboardEvent) => {
        isKeyDown.current = false;

        switch (event?.code) {
            case "Tab":
                break;
            case "KeyH":
                break;
            case "KeyS":
                break;
            case "Escape":
                break;

            default:
                dispatch(setAdvance({ canAdvance: false, skipping: false, keyPressed: store.getState().advance.keyPressed }));
                break;
        }


    };
    const handleScroll = () => {
        document.body.scrollTop = document.documentElement.scrollTop = 0;

    };
    return (
        <div
            onClick={() => _onTouchStart()}
            onWheel={onScroll}
            style={StyleSheet.flatten(style) as CSSProperties}>

            {children}
        </div>
    );
};

